import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const sophosUtm = defineConnector({
  identifier: "sophosUtm",
  name: "Sophos UTM",
  tagLine: "Firewall and gateway management",
  logo,
  protocol: "http",
  tags: ["security", "it"],
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(`${instanceUrl || "https://utm.example.com"}/api`),
  auth: (app) =>
    basicAuth({
      username: "token",
      password: app.secret.apiToken,
    }),
  steps: [
    {
      title: "Create a Sophos UTM API token",
      items: [
        {
          kind: "markdown",
          content:
            "In WebAdmin, go to **Management → WebAdmin Settings → RESTful API**, create a new API token, and copy it.",
        },
      ],
    },
    {
      title: "Enter your Sophos UTM details",
      items: [
        {
          kind: "url",
          label: "Sophos UTM URL",
          placeholder: "https://utm.example.com",
          required: true,
          helperText: "Enter the URL you use for WebAdmin.",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          helperText:
            "Paste the API token from **RESTful API**. 3B uses username `token` automatically.",
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => ({
      url: `${instanceUrl || "https://utm.example.com"}/api/`,
      expectedStatus: [200, 204],
    }),
  },
});
